export function getPercentageClass(value: number | null | undefined): string {
  if (value > 0) return 'positive';
  else if (value < 0) return 'negative';
  else return 'neutral';
}

export function toTitleCase(str: string): string {
  return str
    .toLowerCase()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

export function formatTitleCaseAndRemoveUnderscore(value: string): string {
  if (!value) return '';
  return value
    .toLowerCase()
    .split('_') // remove and split by underscore
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}


export function getStartOfWeek(date: Date): Date {
  const day = date.getDay(); // Sunday = 0
  const diff = date.getDate() - day + (day === 0 ? -6 : 1);
  return new Date(date.setDate(diff));
}

export function getEndOfWeek(date: Date): Date {
  const start = getStartOfWeek(new Date(date)); // clone
  return new Date(start.getTime() + 6 * 24 * 60 * 60 * 1000);
}


export function getGraphTitle(period: any) {
  switch (period) {
    case 'TODAY':
      return `Hours of the Day`;
    case 'WEEK':
      return `Days of the Week`;
    case 'MONTH':
      return `Days of the Month `;
    case 'QUARTER':
      return `Quarters of the Year`;
    case 'YEAR':
      return `Months of the Year`;
    default:
      return '';
  }
}

export function getGraphComparisonTitle(period: any) {
  switch (period) {
    case 'TODAY':
      return `Day-on-Day Comparison`;
    case 'WEEK':
      return `Week-on-Week Comparison`;
    case 'MONTH':
      return `Month-on-Month Comparison`;
    case 'QUARTER':
      return `Quarter-on-Quarter Comparison`;
    case 'YEAR':
      return `Year-on-Year Comparison`;
    default:
      return '';
  }
}